var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pa-12"},[_c('v-range-slider',{attrs:{"tick-labels":_vm.seasons,"value":[0, 1],"min":"0","max":"3","ticks":"always","tick-size":"4"},scopedSlots:_vm._u([{key:"thumb-label",fn:function(props){return [_c('v-icon',{attrs:{"dark":""}},[_vm._v(" "+_vm._s(_vm.season(props.value))+" ")])]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }